import React from 'react';
import '../styles/DateRangePicker.css';

const DateRangePicker = ({
  startDate,
  startTime,
  endDate,
  endTime,
  onStartDateChange,
  onStartTimeChange,
  onEndDateChange,
  onEndTimeChange,
  required = false
}) => {
  return (
    <div className="date-time-inputs">
      <div className="date-time-row">
        <div className="date-time-group">
          <label className="date-time-label">Startdatum</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            required={required}
            className="date-input"
          />
        </div>
        <div className="date-time-group">
          <label className="date-time-label">Startzeit</label>
          <input
            type="time"
            value={startTime}
            onChange={(e) => onStartTimeChange(e.target.value)}
            required={required}
            className="time-input"
          />
        </div>
      </div>
      <div className="date-time-row">
        <div className="date-time-group">
          <label className="date-time-label">Enddatum</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            required={required}
            className="date-input"
          />
        </div>
        <div className="date-time-group">
          <label className="date-time-label">Endzeit</label>
          <input
            type="time"
            value={endTime}
            onChange={(e) => onEndTimeChange(e.target.value)}
            required={required}
            className="time-input"
          />
        </div>
      </div>
    </div>
  );
};

export default DateRangePicker;
